import { FormInstance } from "antd/es/form";
import { Guid } from "guid-typescript";
import _ from "lodash";
import React from "react";
import { IUserInfoDto } from "../../models/dto/user-info.dto";
import { IValidationData } from "../../models/dto/validation-data";
import { UserService } from "../../services/user-service";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IKullaniciForm_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IKullaniciForm_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  GetRolesByName: any[];
  GetRolesByName_dummy: any[];
  GetUserByUsername: any[];
  GetUserByUsername_dummy: any[];
  GetKuserRoleByUserId: any[];
  GetKuserRoleByUserId_dummy: any[];
  isWeb: boolean;
  isWeb_dummy: boolean;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  ReadFromSessionStorage: string;
  ReadFromSessionStorage_dummy: string;
  SetValueOf: any;
  SetValueOf_dummy: any;
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  DeleteFromSessionStorage: string;
  DeleteFromSessionStorage_dummy: string;
  RemoveUserFromRole: boolean;
  RemoveUserFromRole_dummy: boolean;
  UpdateUserInfoByUsername: number;
  UpdateUserInfoByUsername_dummy: number;
  AddUserToRole: boolean;
  AddUserToRole_dummy: boolean;
  KuserProfilePhotoSave: number;
  KuserProfilePhotoSave_dummy: number;
  CreateUser: string;
  CreateUser_dummy: string;
  isComp955387Enabled: "enabled" | "disabled";
  isCompkullaniciform_433225AuthorizationVisible: "visible" | "hidden";
}

export class KullaniciForm_ScreenBase extends React.PureComponent<
  IKullaniciForm_ScreenProps,
  any
> {
  kullaniciform_931314_value_kuikaSelectBoxRef: React.RefObject<any>;
  ml = [
    {
      Id: "f6e17cbf-9877-1e37-1dda-7f0e2f0194a4",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "58f12691-42c0-4569-8d3d-7de148711af0",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "37698f92-569c-4eea-9928-5c3a6c03f94f",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 870882, PropertyName: "value", Value: "Kullancı Tanım" },
        { Id: 240555, PropertyName: "value", Value: "Foto Yükle" },
        { Id: 286561, PropertyName: "value", Value: "E-posta Adresi" },
        {
          Id: 955387,
          PropertyName: "placeholder",
          Value: "E-posta adresinizi yazın...",
        },
        { Id: 857769, PropertyName: "value", Value: "Role" },
        { Id: 931314, PropertyName: "placeholder", Value: "Rol seçiniz..." },
        { Id: 953413, PropertyName: "value", Value: "Ad" },
        { Id: 661322, PropertyName: "placeholder", Value: "Adınızı girin.." },
        { Id: 30937, PropertyName: "value", Value: "Soyad" },
        {
          Id: 821969,
          PropertyName: "placeholder",
          Value: "Soyadınızı girin..",
        },
        { Id: 62018, PropertyName: "value", Value: "Telefon Numarası" },
        {
          Id: 387627,
          PropertyName: "placeholder",
          Value: "Telefon numarasınızı girin...",
        },
        { Id: 433225, PropertyName: "label", Value: "Şifre Değiştir" },
        { Id: 320293, PropertyName: "label", Value: "Kaydet" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.kullaniciform_931314_value_kuikaSelectBoxRef = React.createRef();
    this.kullaniciform_661322_value_kuikaTextInputRef = React.createRef();
    this.kullaniciform_821969_value_kuikaTextInputRef = React.createRef();
    this.kullaniciform_387627_value_kuikaTextInputRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      GetRolesByName: [],
      GetUserByUsername: [],
      GetKuserRoleByUserId: [],
      isWeb: false,
      IfThenElse: false,
      DeleteFromSessionStorage: "",
      NAVIGATE: "",
      isComp955387Enabled: "disabled",
      isCompkullaniciform_433225AuthorizationVisible: "visible",
    };

    this.CheckPageAuthorization(this.state);
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("kullaniciform", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.KullaniciFormPageInit();
    }
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompkullaniciform_433225AuthorizationVisible",
      [
        "6ffd9fd2-9d35-4a3c-4405-1c4e97bb6e8c",
        "8a9da0e3-1949-3a4c-17e4-e92540dae15f",
        "Admin",
        "Bayi",
      ]
    );

    KuikaAppManager.calculateAndSetBodyHeight("kullaniciform", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  CheckPageAuthorization = async (state) => {
    KuikaAppManager.showSpinner(this);
    if (_.isEmpty(window.userInfo)) {
      await UserService.GetUserInfoForce();
    }
    const permittedRoleNames: string[] = ["Admin"];
    const userInfo = window.userInfo as IUserInfoDto;
    const userRoleNames = userInfo.roles.map((role) => role.name);
    if (
      !permittedRoleNames.some((roleName) => userRoleNames.includes(roleName))
    ) {
      await ReactSystemFunctions.goBack(this);

      const language = localStorage.getItem("ml");
      let permissonErrorMessageText =
        "You do not have permission to access this page.";
      if (language === "tr_TR") {
        permissonErrorMessageText = "Bu sayfaya erişim yetkiniz yok.";
      } else if (language === "fr_FR") {
        permissonErrorMessageText =
          "Vous n'avez pas la permission d'accéder à cette page.";
      } else if (language === "de_DE") {
        permissonErrorMessageText =
          "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.";
      } else if (language === "es_ES") {
        permissonErrorMessageText =
          "No tienes permiso para acceder a esta página.";
      }

      KMainFunctions.displayErrorNotification(permissonErrorMessageText);
      state.isPageVisible = false;
      KuikaAppManager.hideSpinner(this);
      return;
    }
    state.isPageVisible = true;
    KuikaAppManager.hideSpinner(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("kullaniciform", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.KullaniciFormPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      kullaniciform_490592_value:
        this.state.GetUserByUsername?.at?.(0)?.profilePhotoUrl ?? undefined,
      kullaniciform_955387_value:
        this.state.GetUserByUsername?.at?.(0)?.username ?? undefined,
      kullaniciform_931314_value:
        this.state.GetKuserRoleByUserId?.at?.(0)?.id ?? undefined,
      kullaniciform_661322_value:
        this.state.GetUserByUsername?.at?.(0)?.firstName ?? undefined,
      kullaniciform_821969_value:
        this.state.GetUserByUsername?.at?.(0)?.lastName ?? undefined,
      kullaniciform_387627_value:
        this.state.GetUserByUsername?.at?.(0)?.phoneNumber ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  KullaniciFormPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      Username_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.UserName ?? this.props.screenInputs.username,
        "string"
      ),
      KuserId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserByUsername !== undefined
            ? stateVars.GetUserByUsername?.length > 0
              ? stateVars.GetUserByUsername[0].id
              : null
            : this.state.GetUserByUsername?.length > 0
            ? this.state.GetUserByUsername[0].id
            : null
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "KullaniciForm/KullaniciFormPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetRolesByName = result?.data.getRolesByName;

    formVars.kullaniciform_931314_value =
      stateVars.GetKuserRoleByUserId !== undefined
        ? stateVars.GetKuserRoleByUserId?.length > 0
          ? stateVars.GetKuserRoleByUserId[0].id
          : null
        : this.state.GetKuserRoleByUserId?.length > 0
        ? this.state.GetKuserRoleByUserId[0].id
        : null;
    formVars.kullaniciform_931314_options = stateVars.GetRolesByName;
    stateVars.GetUserByUsername = result?.data.getUserByUsername;
    formVars.kullaniciform_490592_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetUserByUsername !== undefined
        ? stateVars.GetUserByUsername?.length > 0
          ? stateVars.GetUserByUsername[0].profilePhotoUrl
          : null
        : this.state.GetUserByUsername?.length > 0
        ? this.state.GetUserByUsername[0].profilePhotoUrl
        : null
    );
    formVars.kullaniciform_955387_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetUserByUsername !== undefined
        ? stateVars.GetUserByUsername?.length > 0
          ? stateVars.GetUserByUsername[0].username
          : null
        : this.state.GetUserByUsername?.length > 0
        ? this.state.GetUserByUsername[0].username
        : null
    );
    formVars.kullaniciform_661322_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetUserByUsername !== undefined
        ? stateVars.GetUserByUsername?.length > 0
          ? stateVars.GetUserByUsername[0].firstName
          : null
        : this.state.GetUserByUsername?.length > 0
        ? this.state.GetUserByUsername[0].firstName
        : null
    );
    formVars.kullaniciform_821969_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetUserByUsername !== undefined
        ? stateVars.GetUserByUsername?.length > 0
          ? stateVars.GetUserByUsername[0].lastName
          : null
        : this.state.GetUserByUsername?.length > 0
        ? this.state.GetUserByUsername[0].lastName
        : null
    );
    formVars.kullaniciform_387627_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetUserByUsername !== undefined
        ? stateVars.GetUserByUsername?.length > 0
          ? stateVars.GetUserByUsername[0].phoneNumber
          : null
        : this.state.GetUserByUsername?.length > 0
        ? this.state.GetUserByUsername[0].phoneNumber
        : null
    );
    stateVars.GetKuserRoleByUserId = result?.data.getKuserRoleByUserId;
    formVars.kullaniciform_931314_value =
      stateVars.GetKuserRoleByUserId !== undefined
        ? stateVars.GetKuserRoleByUserId?.length > 0
          ? stateVars.GetKuserRoleByUserId[0].id
          : null
        : this.state.GetKuserRoleByUserId?.length > 0
        ? this.state.GetKuserRoleByUserId[0].id
        : null;
    formVars.kullaniciform_931314_options = stateVars.GetRolesByName;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.KullaniciFormPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  KullaniciFormPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.kullaniciform_490592_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetUserByUsername !== undefined
        ? stateVars.GetUserByUsername?.length > 0
          ? stateVars.GetUserByUsername[0].profilePhotoUrl
          : null
        : this.state.GetUserByUsername?.length > 0
        ? this.state.GetUserByUsername[0].profilePhotoUrl
        : null
    );

    formVars.kullaniciform_955387_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetUserByUsername !== undefined
        ? stateVars.GetUserByUsername?.length > 0
          ? stateVars.GetUserByUsername[0].username
          : null
        : this.state.GetUserByUsername?.length > 0
        ? this.state.GetUserByUsername[0].username
        : null
    );

    stateVars.isComp955387Enabled =
      ReactSystemFunctions.isEqualTo(
        this.props.screenInputs.IsEdit ?? this.props.screenInputs.isedit,
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "enabled"
        : "disabled";
    formVars.kullaniciform_931314_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetKuserRoleByUserId !== undefined
        ? stateVars.GetKuserRoleByUserId?.length > 0
          ? stateVars.GetKuserRoleByUserId[0].id
          : null
        : this.state.GetKuserRoleByUserId?.length > 0
        ? this.state.GetKuserRoleByUserId[0].id
        : null
    );

    stateVars.dataSource_931314 =
      stateVars.GetRolesByName ?? this.state.GetRolesByName;
    stateVars.dataSource_931314 =
      stateVars.GetRolesByName ?? this.state.GetRolesByName;
    formVars.kullaniciform_661322_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetUserByUsername !== undefined
        ? stateVars.GetUserByUsername?.length > 0
          ? stateVars.GetUserByUsername[0].firstName
          : null
        : this.state.GetUserByUsername?.length > 0
        ? this.state.GetUserByUsername[0].firstName
        : null
    );

    formVars.kullaniciform_821969_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetUserByUsername !== undefined
        ? stateVars.GetUserByUsername?.length > 0
          ? stateVars.GetUserByUsername[0].lastName
          : null
        : this.state.GetUserByUsername?.length > 0
        ? this.state.GetUserByUsername[0].lastName
        : null
    );

    formVars.kullaniciform_387627_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetUserByUsername !== undefined
        ? stateVars.GetUserByUsername?.length > 0
          ? stateVars.GetUserByUsername[0].phoneNumber
          : null
        : this.state.GetUserByUsername?.length > 0
        ? this.state.GetUserByUsername[0].phoneNumber
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  KullaniciFormComponent_155125_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  KullaniciFormComponent_240555_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.isWeb = await ReactSystemFunctions.isWeb();

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.KullaniciFormComponent_240555_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  KullaniciFormComponent_240555_onClick_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "FotoDrawer",
      "sessionName",
      ReactSystemFunctions.convertToTypeByName("UserPhoto", "string")
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      this.KullaniciFormComponent_240555_onClick_if11_,
      "KullaniciForm",
      "FotoDrawer",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "760251",
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };
  KullaniciFormComponent_240555_onClick_if11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ReadFromSessionStorage =
      await ReactSystemFunctions.readFromSessionStorage(
        ReactSystemFunctions.convertToTypeByName("UserPhoto", "string")
      );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "kullaniciform_490592_value",
        "string"
      ),
      ReactSystemFunctions.value(this, stateVars.ReadFromSessionStorage),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  KullaniciFormComponent_240555_onClick_else1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "FotoDrawer",
      "sessionName",
      ReactSystemFunctions.convertToTypeByName("UserPhoto", "string")
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      this.KullaniciFormComponent_240555_onClick_else11_,
      "KullaniciForm",
      "FotoDrawer",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "372291",
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };
  KullaniciFormComponent_240555_onClick_else11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ReadFromSessionStorage =
      await ReactSystemFunctions.readFromSessionStorage(
        ReactSystemFunctions.convertToTypeByName("UserPhoto", "string")
      );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "kullaniciform_490592_value",
        "string"
      ),
      ReactSystemFunctions.value(this, stateVars.ReadFromSessionStorage),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  KullaniciFormComponent_240555_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.isWeb),
        true
      )
    ) {
      isErrorOccurred = await this.KullaniciFormComponent_240555_onClick_if1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.KullaniciFormComponent_240555_onClick_else1();
      if (isErrorOccurred) return true;
    }

    stateVars.DeleteFromSessionStorage =
      await ReactSystemFunctions.deleteFromSessionStorage(
        ReactSystemFunctions.convertToTypeByName("UserPhoto", "string")
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  KullaniciFormComponent_433225_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "NewPass",
      "PrmUserName",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.UserName ?? this.props.screenInputs.username,
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "KullaniciForm",
      "NewPass",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "764533",
      null,
      null,
      "true",
      "80vw",
      "70vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  KullaniciFormComponent_320293_onClick_if0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isValidEmail(
        ReactSystemFunctions.value(
          this,
          "kullaniciform_955387_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "Geçerli bir mail adresi giriniz.",
      formName: "kullaniciform_955387_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.RemoveUserFromRole =
      await ReactSystemFunctions.removeUserFromRole(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetKuserRoleByUserId !== undefined
            ? stateVars.GetKuserRoleByUserId?.length > 0
              ? stateVars.GetKuserRoleByUserId[0].name
              : null
            : this.state.GetKuserRoleByUserId?.length > 0
            ? this.state.GetKuserRoleByUserId[0].name
            : null
        ),
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "kullaniciform_955387_value",
            "value",
            "",
            "",
            ""
          )
        )
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.KullaniciFormComponent_320293_onClick_if01_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  KullaniciFormComponent_320293_onClick_if01_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      FirstName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "kullaniciform_661322_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      LastName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "kullaniciform_821969_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      PhoneNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "kullaniciform_387627_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Username_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.UserName ?? this.props.screenInputs.username,
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "KullaniciForm/KullaniciFormComponent_320293_onClick_if01_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.UpdateUserInfoByUsername = result?.data.updateUserInfoByUsername;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.KullaniciFormComponent_320293_onClick_if02_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  KullaniciFormComponent_320293_onClick_if02_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isValidEmail(
        ReactSystemFunctions.value(
          this,
          "kullaniciform_955387_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "Geçerli bir mail adresi giriniz.",
      formName: "kullaniciform_955387_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    stateVars.AddUserToRole = await ReactSystemFunctions.addUserToRole(
      ReactSystemFunctions.toString(
        this,
        ReactSystemFunctions.value(
          this,
          "kullaniciform_931314_value",
          "value",
          "GetRolesByName",
          "id",
          "name"
        )
      ),
      ReactSystemFunctions.value(
        this,
        ReactSystemFunctions.value(
          this,
          "kullaniciform_955387_value",
          "value",
          "",
          "",
          ""
        )
      )
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.KullaniciFormComponent_320293_onClick_if03_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  KullaniciFormComponent_320293_onClick_if03_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ImageId_0: ReactSystemFunctions.convertToTypeByName(
        Guid.create().toString(),
        "Guid"
      ),
      KuserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserByUsername !== undefined
            ? stateVars.GetUserByUsername?.length > 0
              ? stateVars.GetUserByUsername[0].id
              : null
            : this.state.GetUserByUsername?.length > 0
            ? this.state.GetUserByUsername[0].id
            : null
        ),
        "Guid"
      ),
      ImageBase64_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "kullaniciform_490592_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "KullaniciForm/KullaniciFormComponent_320293_onClick_if03_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.KuserProfilePhotoSave = result?.data.kuserProfilePhotoSave;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  KullaniciFormComponent_320293_onClick_else0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isValidEmail(
        ReactSystemFunctions.value(
          this,
          "kullaniciform_955387_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "Geçerli bir mail adresi giriniz.",
      formName: "kullaniciform_955387_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.CreateUser = await ReactSystemFunctions.createUser(
      ReactSystemFunctions.value(
        this,
        ReactSystemFunctions.value(
          this,
          "kullaniciform_955387_value",
          "value",
          "",
          "",
          ""
        )
      ),
      ReactSystemFunctions.value(
        this,
        ReactSystemFunctions.value(
          this,
          "kullaniciform_661322_value",
          "value",
          "",
          "",
          ""
        )
      ),
      ReactSystemFunctions.value(
        this,
        ReactSystemFunctions.value(
          this,
          "kullaniciform_821969_value",
          "value",
          "",
          "",
          ""
        )
      ),
      "",
      ReactSystemFunctions.value(
        this,
        ReactSystemFunctions.value(
          this,
          "kullaniciform_387627_value",
          "value",
          "",
          "",
          ""
        )
      ),
      ""
    );
    stateVars.AddUserToRole = await ReactSystemFunctions.addUserToRole(
      ReactSystemFunctions.toString(
        this,
        ReactSystemFunctions.value(
          this,
          "kullaniciform_931314_value",
          "value",
          "GetRolesByName",
          "id",
          "name"
        )
      ),
      ReactSystemFunctions.value(
        this,
        ReactSystemFunctions.value(
          this,
          "kullaniciform_955387_value",
          "value",
          "",
          "",
          ""
        )
      )
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.KullaniciFormComponent_320293_onClick_else01_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  KullaniciFormComponent_320293_onClick_else01_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ImageId_0: ReactSystemFunctions.convertToTypeByName(
        Guid.create().toString(),
        "Guid"
      ),
      KuserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserByUsername !== undefined
            ? stateVars.GetUserByUsername?.length > 0
              ? stateVars.GetUserByUsername[0].id
              : null
            : this.state.GetUserByUsername?.length > 0
            ? this.state.GetUserByUsername[0].id
            : null
        ),
        "Guid"
      ),
      ImageBase64_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "kullaniciform_490592_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "KullaniciForm/KullaniciFormComponent_320293_onClick_else01_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.KuserProfilePhotoSave = result?.data.kuserProfilePhotoSave;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  KullaniciFormComponent_320293_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        this.props.screenInputs.IsEdit ?? this.props.screenInputs.isedit,
        true
      )
    ) {
      isErrorOccurred = await this.KullaniciFormComponent_320293_onClick_if0();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.KullaniciFormComponent_320293_onClick_else0();
      if (isErrorOccurred) return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [760251, 372291, 764533] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.KullaniciFormPageInit();
    }
    if (diId == 760251) {
      isErrorOccurred =
        await this.KullaniciFormComponent_240555_onClick_if11_();
      if (isErrorOccurred) return true;
    } else if (diId == 372291) {
      isErrorOccurred =
        await this.KullaniciFormComponent_240555_onClick_else11_();
      if (isErrorOccurred) return true;
    }
  }
}
